import { render, staticRenderFns } from "./ArrangementsCard.vue?vue&type=template&id=42c42a5e&"
import script from "./ArrangementsCard.vue?vue&type=script&lang=js&"
export * from "./ArrangementsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports